import { makeStyles } from 'tss-react/mui';

const useStyles = makeStyles()(theme => ({
    buttons: {
        position: "fixed",
        bottom: theme.spacing(2),
        right: theme.spacing(2)
    },
    fab: {
        margin: `0px ${theme.spacing(1)}`
    },
    extendedIcon: {
        marginRight: theme.spacing(1),
    }
}));

export default useStyles;